import {
    ttsVoiceAgeFilter,
    ttsVoiceFunctionFilter,
    ttsVoiceGenderFilter,
    ttsVoiceLanguageFilter,
    ttsVoiceProviderFilter,
    ttsVoiceSearchFilter,
    ttsVoiceTierFilter,
    ttsVoiceUseCaseFilter,
} from '@/state/presenters';
import { useSetRecoilState } from 'recoil';

export const useFiltersReset = () => {
    const setTtsVoiceSearchFilter = useSetRecoilState(ttsVoiceSearchFilter);
    const setTtsVoiceLanguageFilter = useSetRecoilState(ttsVoiceLanguageFilter);
    const setTtsVoiceGenderFilter = useSetRecoilState(ttsVoiceGenderFilter);
    const setTtsVoiceAgeFilter = useSetRecoilState(ttsVoiceAgeFilter);
    const setTtsVoiceUseCaseFilter = useSetRecoilState(ttsVoiceUseCaseFilter);
    const setTtsVoiceTierFilter = useSetRecoilState(ttsVoiceTierFilter);
    const setTtsVoiceFunctionFilter = useSetRecoilState(ttsVoiceFunctionFilter);
    const setTtsVoiceProviderFilter = useSetRecoilState(ttsVoiceProviderFilter);

    const handleReset = () => {
        setTtsVoiceSearchFilter('');
        setTtsVoiceLanguageFilter('all');
        setTtsVoiceGenderFilter('all');
        setTtsVoiceAgeFilter('all');
        setTtsVoiceUseCaseFilter('all');
        setTtsVoiceTierFilter('all');
        setTtsVoiceFunctionFilter([]);
        setTtsVoiceProviderFilter([]);
    };

    return { reset: handleReset };
};
